import css from 'styled-jsx/css';

const styles = css.global`body.stop-scroll {
  overflow: hidden !important;
}
`;

export default styles;